'use client';

import React, { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@ecom/helper-react-class-combine';
import { useCarouselContext } from '../carousel-context';

interface ArrowProps {
  className?: string;
  /** Custom icon. Falls back to a chevron when omitted. */
  children?: ReactNode;
}

export function CarouselNext({ className, children }: ArrowProps): React.ReactElement | null {
  const { canNext, scrollNext, slideCount, labels } = useCarouselContext();
  if (slideCount <= 1) return null;
  return (
    <button
      type='button'
      aria-label={labels.nextSlide}
      onClick={scrollNext}
      disabled={!canNext}
      className={cn(
        'disabled:pointer-events-none disabled:opacity-40',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current',
        className,
      )}
    >
      {children ?? <ChevronRight size={32} aria-hidden='true' />}
    </button>
  );
}
